import { render, staticRenderFns } from "./BudgetHeadTree.vue?vue&type=template&id=583dd460&scoped=true"
import script from "./BudgetHeadTree.vue?vue&type=script&lang=js"
export * from "./BudgetHeadTree.vue?vue&type=script&lang=js"
import style0 from "./BudgetHeadTree.vue?vue&type=style&index=0&id=583dd460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583dd460",
  null
  
)

export default component.exports